import { resolveLexicalSubmissionContext } from '#pplx/frontend/apps/ask/ask-input/query-serialization/lexicalNodeToQuery.js';
import { replaceSubmitTabMentions } from '#pplx/frontend/apps/ask/composer-ui/normalizeSubmitMentions.js';
/**
 * Combines input surface fields with the rich-draft values used by Ask Input.
 * Explicit mentions and Skills take precedence over editor values. When browser-tab state is
 * supplied, its current selection replaces stale tab mentions from the editor.
 *
 * @returns The normalized fields to merge into the input submission payload.
 */
export function normalizeComposerSubmissionContext({ routeContext = {}, serializedEditorState, browserTabs, }) {
    const lexicalSubmissionContext = resolveLexicalSubmissionContext({
        rootNode: serializedEditorState?.root,
        mentions: routeContext.mentions,
        prefills: routeContext.prefills,
        slashCommand: routeContext.slashCommand,
        slashCommandSubmittedLabel: routeContext.slashCommandSubmittedLabel,
    });
    const submissionMentions = browserTabs === undefined
        ? lexicalSubmissionContext.mentions
        : replaceSubmitTabMentions({
            activeTab: browserTabs.activeTab,
            attachedTabs: browserTabs.attachedTabs,
            mentions: lexicalSubmissionContext.mentions,
        });
    return {
        ...routeContext,
        ...lexicalSubmissionContext,
        mentions: submissionMentions,
    };
}
//# sourceMappingURL=composerSubmissionContext.js.map